import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

export type RemarksPopupDialogRequestData = {
  title: string;
  subTitle: string;
  isRequired: boolean;
  icon: string;
  buttonAction: 'continue' | 'save';
};

export type RemarksPopupDialogResponseData = {
  remarks: string;
};

@Component({
  selector: 'app-remarks-popup',
  templateUrl: './remarks-popup.component.html',
  styleUrls: ['./remarks-popup.component.scss'],
})
export class RemarksPopupComponent {
  remarksFormGroup = new FormGroup({
    remarks: new FormControl(null),
  });
  title: string;
  subTitle: string;
  isRequired: boolean;
  icon: string;
  buttonAction: string;
  buttonText: string;

  constructor(
    private translate: TranslateService,
    private readonly matDialog: MatDialogRef<RemarksPopupComponent>,
    @Inject(MAT_DIALOG_DATA)
    private readonly data: RemarksPopupDialogRequestData
  ) {
    this.title = this.data?.title;
    this.subTitle = this.data?.subTitle;
    this.icon = this.data?.icon;
    this.buttonText =
      this.data.buttonAction === 'continue'
        ? this.translate.instant('shared.remarks-popup.continue')
        : this.translate.instant('shared.remarks-popup.save');

    if (this.data?.isRequired) {
      this.isRequired = true;
      this.remarksFormGroup.controls.remarks.setValidators([
        Validators.required,
      ]);
      this.remarksFormGroup.updateValueAndValidity();
    }
  }

  outputData() {
    return {
      remarks: this.remarksFormGroup.controls.remarks.value,
    };
  }
  onClickClose() {
    this.matDialog.close();
  }
}
